import React from 'react';

import WidgetNewportAppSettingsEditor from 'widgets/WidgetSettingsEditing/WidgetNewportAppSettingsEditor';
import { useWidgetConfigUpdater } from 'widgets/WidgetSettingsEditing/useWidgetConfigUpdater';

import { CapsuleSettingsSymbolEditor } from 'widgets/tiles/components/tile/CapsuleSettingsSymbolEditor';
import { CorporateActionsCapsuleConfigState } from 'widgets/corpActions/capsule/store/CorporateActionsCapsuleConfigState';
import { useCorporateActionsCapsuleConfigSlice } from 'widgets/corpActions/capsule/store/configslice';
import WidgetSettingsCheckboxValueEditor from 'widgets/WidgetSettingsEditing/WidgetSettingsCheckboxValueEditor';

export const CorporateActionsCapsuleSettingsText = `Events Capsule Settings`;

export interface CorporateActionsCapsuleSettingsProps {
    config?: CorporateActionsCapsuleConfigState;
    onChange?: (nextDelta: Partial<CorporateActionsCapsuleConfigState>) => void;
}

export default function CorporateActionsCapsuleSettings(
    props: CorporateActionsCapsuleSettingsProps
) {
    const { onChange, config: propsConfig } = props;
    const { config: configSliceConfig, dispatchConfigChanged } =
        useCorporateActionsCapsuleConfigSlice();

    const { debouncedApplyWidgetConfigChange } = useWidgetConfigUpdater(
        dispatchConfigChanged,
        onChange
    );
    const config = propsConfig ?? configSliceConfig;

    return (
        <div className="CorporateActionsCapsuleSettings">
            <CapsuleSettingsSymbolEditor
                config={config}
                onChange={debouncedApplyWidgetConfigChange}
                group={true}
            />

            <div className="group">
                <div>Include</div>

                <WidgetSettingsCheckboxValueEditor
                    config={config}
                    label="Historical"
                    propertyName={'excludeHistorical'}
                    inverted={true}
                    onChange={debouncedApplyWidgetConfigChange}
                />

                <WidgetSettingsCheckboxValueEditor
                    config={config}
                    label="Future"
                    inverted={true}
                    propertyName={'excludeUpcoming'}
                    onChange={debouncedApplyWidgetConfigChange}
                />

                <WidgetSettingsCheckboxValueEditor
                    config={config}
                    label="Todays"
                    inverted={true}
                    propertyName={'excludeToday'}
                    onChange={debouncedApplyWidgetConfigChange}
                />
            </div>

            <WidgetNewportAppSettingsEditor
                specifyVisibleControls={{
                    showTooltips: false,
                    showChartHelp: true,
                    symbology: true,
                }}
            />
        </div>
    );
}
